module.exports = __webpack_public_path__ + "static/media/tech-world.e5d950f2.png";